import { useEffect } from 'react';

export default function CursorTrail() {
  useEffect(() => {
    const TRAIL_COUNT = 12;
    const trails = [];

    for (let i = 0; i < TRAIL_COUNT; i++) {
      const d = document.createElement('div');
      const size = 8 - i * 0.5;
      d.style.cssText = `
        position:fixed;
        width:${size}px;
        height:${size}px;
        border-radius:50%;
        background:#63ba46;
        pointer-events:none;
        z-index:9999;
        transform:translate(-50%,-50%);
        opacity:0;
        box-shadow:0 0 10px #63ba46, 0 0 20px rgba(99,186,70,0.4);
        transition:opacity 0.3s;
        will-change:left,top;
      `;
      document.body.appendChild(d);
      trails.push({ el: d, x: 0, y: 0 });
    }

    let mx = 0, my = 0;
    const onMove = e => { mx = e.clientX; my = e.clientY; };
    document.addEventListener('mousemove', onMove);

    let raf;
    function animTrail() {
      let px = mx, py = my;
      trails.forEach((t, i) => {
        t.x += (px - t.x) * 0.3;
        t.y += (py - t.y) * 0.3;
        t.el.style.left = t.x + 'px';
        t.el.style.top = t.y + 'px';
        t.el.style.opacity = ((TRAIL_COUNT - i) / TRAIL_COUNT) * 0.6;
        px = t.x; py = t.y;
      });
      raf = requestAnimationFrame(animTrail);
    }
    animTrail();

    return () => {
      cancelAnimationFrame(raf);
      document.removeEventListener('mousemove', onMove);
      trails.forEach(t => t.el.remove());
    };
  }, []);

  return null;
}
